import styled from 'styled-components';
import { color } from 'asserts/styles/colors';

const CompanyList = () => {
  const logoNames = [
    'samsung',
    'ncsoft',
    'naver',
    'hd',
    'skhynix',
    'isolation',
    'koreapark',
    'kepco',
    'hdsteel',
    'kfa',
    'hanhwa',
    'amore',
    'amway',
    'bodyfriend',
    'oil',
    'hospital',
    'checkup',
    'kuni',
    'besthospital',
    'wonju'
  ];

  return (
    <Wrapper>
      {logoNames.map((logoName, index) => (
        <PartnerLogoWrapper key={index}>
          <img
            src={require(`asserts/logo/company/${logoName}.svg`)}
            alt={`Company Logo ${index + 1}`}
            loading="lazy"
          />
        </PartnerLogoWrapper>
      ))}
    </Wrapper>
  );
};

export default CompanyList;

const Wrapper = styled.div`
  width: 1104px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 0 auto;
`;

const PartnerLogoWrapper = styled.div`
  position: relative;
  width: 208px;
  height: 116px;
  border-radius: 16px;
  border: 1px solid ${color.gray300};
  background: ${color.white};

  img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;
